/* tslint:disable:no-console */

const info = (message: string): void => {
   if (console.log) {
      console.log(message);
   }
};

const warn = (message: string): void => {
   if (console.log) {
      console.log(message);
   }
};

export default {
   info,
   warn
};
